import * as angular from 'angular';
import * as _ from 'lodash';

import {
    IApprovalStrategy,
    ComponentDefinition,
    JustificationLevel,
    AutoApprovalMethod,
    TimeUnit,
    IFrequencyValidationRule,
    IFrequency,
    Tuple,
    ApplicationUserViewModel
} from '../../models';

class ApprovalStrategyLevelsController implements angular.IComponentController {
    isLoading: boolean;
    formController: angular.IFormController;
    isEditMode: boolean;
    strategy: IApprovalStrategy;
    freqRules: IFrequencyValidationRule[];
    autoApprovalAllowedTimeUnits: Tuple<TimeUnit, string>[];
    users: ApplicationUserViewModel[];

    static $inject = [];
    constructor() {
        this.freqRules = [
            {
                key: 'interval',
                isValid: (f: IFrequency) => f.intervalTimeUnit === TimeUnit.Day || f.intervalTimeUnit === TimeUnit.Hour
            }
        ];

        this.autoApprovalAllowedTimeUnits = [
            { key: TimeUnit.Hour, value: 'Hour' },
            { key: TimeUnit.Day, value: 'Day' },
        ];
    }

    create() {
        this.strategy.approbationStrategyLevelCollection.push({
            level: _.maxBy(this.strategy.approbationStrategyLevelCollection, d => d.level).level + 1,
            roleCollection: [],
            userCollection: [],
            justificationLevel: JustificationLevel.Never,
            autoApprovalMethod: AutoApprovalMethod.None,
            autoApprovalDelay: { interval: 0, intervalTimeUnit: TimeUnit.Day }
        });
        this.formController.$setDirty();
    }

    delete(level) {
        _.remove(this.strategy.approbationStrategyLevelCollection, d => d.level === level.level);
        this.formController.$setDirty();
    }
}

export const wtApprovalStrategyLevels: ComponentDefinition = {
    componentId: 'wtApprovalStrategyLevels',
    controller: ApprovalStrategyLevelsController,
    controllerAs: 'vm',
    template: require('./approvalStrategyLevels.component.html'),
    bindings: {
        strategy: '<',
        users: '<',
        roles: '<',
        isEditMode: '<',
        formController: '='
    }
};